interface  AbortFunction {
  (abortPromise?: Promise<boolean>): void;
  promise: Promise<boolean>;
}

export default function createAbort(): AbortFunction {
  const fn: AbortFunction = (abortPromise?: Promise<boolean>): void => {
    fn.promise = abortPromise || Promise.resolve(true);
  };

  fn.promise = Promise.resolve(false);

  return fn;
}
